<template>
  <v-app>
    <v-toolbar color="primary"
               dark
               fixed
               app>
      <v-spacer></v-spacer>
      <router-link to="/"
                   class="align-self-end">
        <img src="/image/logo_bg_white.png"
             width="200px"
             height="40px" />
      </router-link>
      <v-spacer></v-spacer>

    </v-toolbar>

    <v-content app>
      <v-container fluid
                   class="minHeight">
        <v-layout justify-center>
          <v-flex xs12
                  md8>
            <router-view></router-view>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>

    <wsp-footer expandedFooter></wsp-footer>
  </v-app>
</template>

<script>
import { EventBus } from '@/services/eventBus';
import keys from '@/store/keys';
import WspFooter from '@/components/commons/WspFooter';

export default {
  name: 'LoginLayout',
  components: {
    [WspFooter.name]: WspFooter
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      document.title = vm.$i18n.t(to.meta.i18nTitle);
    });
  },
  data: () => ({
  }),
  created() {
    EventBus.$on(keys.eventOnLanguageChanged, this.changeLanguage);
  },
  destroyed() {
    EventBus.$off(keys.eventOnLanguageChanged, this.changeLanguage);
  },
  methods: {
    changeLanguage: function(params) {
      this.$router.replace(this.$i18n.t(this.$route.meta.i18nUrlLabel, this.$route.params));
    }
  }
};
</script>

<style lang="scss">
@import '~@/assets/css/public.scss';
</style>
